import queryString from 'query-string'
import api from '@utils/api'
import {$http, http} from '@utils'

export default {
    namespaced: true,
    state:{
    },
    actions:{
        async getInfo4CZJ({ commit }, {businessId}) {
            const param = JSON.stringify({
                businessId
            })
            const res = await $http.post(`${api.mainHost}/portal-api/account/getAccountStoreNums.do`, queryString.stringify({param}), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                credentials: 'include',
                withCredentials: true,
            })
            return res
        },
        /**
         * 获取成长加账号店长信息
         * start: 0
         * 
         */
        async getList4CZJ({ commit }, { businessId, start, rows }) {
            const param = JSON.stringify({
                businessId, start, rows
            })
            const res = await $http.post(`${api.mainHost}/portal-api/account/getAccountStores.do`, queryString.stringify({param}), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                credentials: 'include',
                withCredentials: true,
            })
            return res
        },
        async getList({ commit }) {
            const res = await $http.get(`${api.mainHost}/portal-api/account/getAccountBaseInfo.do?rd=${new Date().getTime()}`, {
                credentials: 'include',
                withCredentials: true,
            })
            return res && res.data
        },
        async getInfoByPhone({ commit }, { phone }) {
            const param = queryString.stringify({
                phone
            })
            const res = await http.get(`${api.mainHost}/portal-api/account/getUserNameByMobile.do?${param}`)
            return res
        },
        async unbind({commit}, {buzzId, userId }) {
            const param = JSON.stringify({
                buzzId, userId
            })
            const res = await $http.post(`${api.mainHost}/portal-api/account/unBindStoreAccount.do`, queryString.stringify({param}), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            })
            return res
        },
        async save({ commit }, { userName, password, comfirmPwd, phone, email, buzzId, buzzType, phoneIdentity, phoneServiceCode, phoneVcode, accountName }) {
            const param = JSON.stringify({
                userName, password, comfirmPwd, phone, email, buzzId, phoneIdentity, phoneServiceCode, phoneVcode, accountName, buzzType
            })
            const res = await $http.post(`${api.mainHost}/portal-api/account/bindStoreUser.do`, queryString.stringify({param}), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                credentials: 'include',
                withCredentials: true,
            })
            return res
        }
    }
}
